/**
 * Selectors
 */
const selectDictionaryForLanguage = (state) => {
  const { taxonsDictionary } = state.shopTaxons;
  const { lang } = state.i18nState;
  if (taxonsDictionary && lang && taxonsDictionary[lang]) {
    return taxonsDictionary[lang];
  }
  return false;
};

/** exports all actions as default */
const taxonSelectors = {
  selectDictionaryForLanguage: selectDictionaryForLanguage,
};

export default taxonSelectors;
